module.exports = __webpack_public_path__ + "static/media/NetlightLogo.e5255133.svg";